import styled from 'styled-components';

export const StyledTagsItem = styled.div`
  padding: 4px ${(p) => p.theme.space[3]};
  box-shadow: ${(p) => p.theme.shadows.all};
  border-radius: ${(p) => p.theme.radii.pill};
`;
